module.exports = __webpack_public_path__ + "img/icon-03.1e7859e7.png";